export const TwentyFour = 'r';  